import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2b08873e&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=2b08873e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08873e",
  null
  
)

export default component.exports